var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourseMenuTools(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.44188 0C4.13639 0 0.62793 3.592 0.62793 8C0.62793 12.408 4.13639 16 8.44188 16C12.7474 16 16.2558 12.408 16.2558 8C16.2558 3.592 12.7474 0 8.44188 0ZM12.177 6.16L7.74644 10.696C7.63705 10.808 7.48858 10.872 7.3323 10.872C7.17602 10.872 7.02756 10.808 6.91816 10.696L4.70681 8.432C4.48021 8.2 4.48021 7.816 4.70681 7.584C4.93342 7.352 5.30849 7.352 5.53509 7.584L7.3323 9.424L11.3487 5.312C11.5753 5.08 11.9503 5.08 12.177 5.312C12.4036 5.544 12.4036 5.92 12.177 6.16Z",
    fill: "#171717"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseMenuTools);
export default __webpack_public_path__ + "static/media/course_menu_tools.8c64d07f793334fb30ec67cca49867a6.svg";
export { ForwardRef as ReactComponent };